function isTeaserPriceType (pt) {
  // let isTeaserPriceType = pt.slice(0, 1) === 'T' || pt.slice(0, 2) === 'RT' || (pt.includes('T') && pt.includes('.'))
  let isTeaserPriceType = (pt.includes('T') || pt.includes('RT')) && pt.split('T')[1] && !isNaN(pt.split('T')[1])
  return isTeaserPriceType
}
function isTeaserReversed (pt) {
  let isTeaserReversed = pt.slice(0, 2) === 'RT'
  return isTeaserReversed
}

export default {
  isTeaserPriceType,
  isTeaserReversed
}



// WEBPACK FOOTER //
// ./src/library/teaserPriceType/index.js